import axios from 'axios'

export default {
  get (id) {
    return axios.get('checkpoint/' + id)
  },
  add (checkpoint) {
    return axios.post('checkpoint', checkpoint)
  },
  save (checkpoint) {
    return axios.put('checkpoint/' + checkpoint.id, checkpoint)
  },
  delete (checkpoint) {
    return axios.delete('checkpoint/' + checkpoint.id)
  },
  getAllByEvent (token) {
    return axios.get('event/' + token + '/checkpoints')
  },
  getByToken (token) {
    return axios.get('event/checkpoint/' + token)
  }
}
